<template>
  <div class="recommend" ref="container">
    <div class="promoterHeader">
      <div class="item acea-row1 row-between-wrapper">
        <div class="pictrue">
          <img class="image" :src="info.img" />
        </div>
        <div class="underline">
          <div class="text">
            <div style="letter-spacing:2px">{{ info.name }}</div>
            <div style="font-size: 12px;margin-top: 5px;color: #6C6C6C;">
              规格：{{ info.spec }}
            </div>
            <div style="color: #6C6C6C;font-size: 12px;margin-top: 5px">
              配送范围：{{ info.area }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: -14px">
      <div class="title acea-row row-center-wrapper">
        <span class="iconfont icon-zhuangshixian"></span>
        <span class="name">券卡信息</span>
        <span class="iconfont icon-zhuangshixian lefticon"></span>
      </div>

      <div class="giftticket">
        <div class="item acea-row row-between-wrapper">
          <div class="label acea-row">
            <span>券卡类型</span>
          </div>
          <div class="value">{{ info.type }}{{ info.cate }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="label acea-row">
            <span>券卡状态</span>
          </div>
          <div class="value">
            <span style="color:#00CACA" v-if="info.status === 1">未使用</span>
            <span style="color:#FF5151" v-else-if="info.status === 2"
              >使用中</span
            >
            <span style="color:#FF5151" v-else-if="info.status === 3"
              >已使用</span
            >
            <span style="color:#FF5151" v-else-if="info.status === 4"
              >已过期</span
            >
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="label acea-row">
            <span>券卡编码</span>
          </div>
          <div class="value">
            <span>{{ info.code }}</span>
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="label acea-row">
            <span>可用次数</span>
          </div>
          <div class="value">
            <span>{{ info.available }}次</span>
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="label acea-row">
            <span>有效期</span>
          </div>
          <div class="value">
            <span>{{ info.startTime }}</span>
            <br />
            <span>~</span>
            <br />
            <span>{{ info.endTime }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer acea-row row-between-wrapper" v-if="info.status === 2">
      <div
        class="addressBnt on"
        @click="$router.push({ path: '/giftticket/result/' + info.code })"
      >
        查看已使用提货信息
      </div>
    </div>
    <div
      class="footer acea-row row-between-wrapper"
      v-if="info.status === 1 || info.status === 2"
    >
      <div
        class="addressBnt on bg-color-red"
        @click="$router.push({ path: '/giftticket/takeGoods/' + info.code })"
        v-if="pickSttaus === 0"
      >
        我要提货
      </div>
      <div class="addressBnt2 on bg-color-red" v-else-if="pickSttaus === 1">
        未到提货开始时间
      </div>
      <div class="addressBnt2 on" v-else>
        提货时间已过期
      </div>
    </div>
  </div>
</template>
<script>
import { getGiftTicket } from "@api/giftticket";

export default {
  name: "giftticket",
  components: {},
  props: {},
  data: function() {
    return {
      info: {},
      commission: 0,
      code: "",
      pickSttaus: 0
    };
  },
  mounted: function() {
    this.code = this.$route.params.code;
    this.getData();
  },
  methods: {
    getData() {
      getGiftTicket(this.code)
        .then(res => {
          if (res.data.name == null) {
            this.$dialog.toast({ mes: "未查询到卡信息" });
            setTimeout(() => {
              this.$router.push({ path: "/giftticket/subscribe" });
            }, 1000);
          } else {
            this.info = res.data;
            var date1 = new Date(res.data.startTime);
            var date2 = new Date(res.data.endTime);
            var date3 = new Date();
            if (date3.getTime() < date1.getTime()) {
              this.pickSttaus = 1;
            }
            if (date2.getTime() < date3.getTime()) {
              this.pickSttaus = 2;
            }
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg);
          setTimeout(() => {
            this.$router.push({ path: "/giftticket/subscribe" });
          }, 2000);
        });
    }
  }
};
</script>

<style scoped>
.footer {
  position: fixed;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  height: 1.06rem;
  padding: 0 0.3rem;
}
.footer .addressBnt {
  width: 3.3rem;
  height: 0.76rem;
  text-align: center;
  line-height: 0.76rem;
  font-size: 0.3rem;
  color: #fff;
}
.footer .addressBnt.on {
  width: 6.9rem;
  margin: 0 auto;
}
.bg-color-red {
  background-color: #ea3526 !important;
}
.footer .addressBnt2 {
  width: 3.3rem;
  height: 0.76rem;
  text-align: center;
  line-height: 0.76rem;
  font-size: 0.3rem;
  color: #fff;
  background-color: #f36d63 !important;
}
.footer .addressBnt2.on {
  width: 6.9rem;
  margin: 0 auto;
}
.iconfont {
  font-size: 0.2rem;
}

.item {
  position: relative;
  padding-left: 0.3rem;
  background-color: #f0f0f0;
}
.acea-row1 {
  display: -webkit-box;
}
.acea-row1.row-between-wrapper {
  -webkit-box-pack: justify;
}
.item .pictrue {
  width: 1.8rem;
  height: 1.8rem;
  position: relative;
}
.item .pictrue .image {
  width: 80%;
  height: 80%;
  border-radius: 0.06rem;
  margin-top: 9px;
}
.item .underline {
  padding: 0.3rem 0.3rem 0.3rem 0;
}
.item .text {
  font-size: 0.3rem;
  color: #222;
  width: 4.89rem;
  text-align: left;
}
</style>
